import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getPartnerMarketingHomeBlocks } from "app/reducers/partnerSelector";
import SmartDP from "app/pages/SmartDP/SmartDP";
import { getQuoteStatus } from "app/pages/Booking/Quotation/quotationSelectors";
import {
	fetchSDPAvailableDepartureDate,
	fetchSDPFilters,
} from "app/pages/SmartDP/smartDPActionCreators";

const mapStateToProps = state => {
	return {
		homeBlocks: getPartnerMarketingHomeBlocks(state),
		fetchSDPProductsStatus: state.smartDP.status,
		fetchSDPAvailabilitiesStatus: getQuoteStatus(state),
		hasSdpSpecialOffer: state.smartDP.specialOffer, // true si le back renvoi au moins un vol remboursable
		specialOfferInfos: state.smartDP.specialOfferInfos,
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{
			fetchSDPFilters,
			fetchSDPAvailableDepartureDate,
		},
		dispatch
	);
};
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SmartDP);
